import { Building07Icon } from 'icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from 'styles/colors';
import { Divider } from '../Divider';
import { GraphTooltip } from '../GraphTooltip';
import { Circle } from '../GraphTooltip/styles';
import { TooltipContainer, TooltipRow } from './styles';

interface PercentageTooltipProps {
  date: string;
  percentage: number;
  color: string;
  description: string;
  units: number;
  type: 'month' | 'day';
  dataTestId?: string;
}

export function PercentageTooltip({
  color,
  date,
  description,
  percentage,
  units,
  type,
  dataTestId,
}: Readonly<PercentageTooltipProps>): ReactElement {
  const { t } = useTranslation();
  return (
    <GraphTooltip
      date={date}
      type={type}
      style={{ height: 116 }}
      dataTestId={dataTestId}
    >
      <TooltipContainer>
        <TooltipRow>
          <Circle color={color} />
          <span>{description}</span>
          <span>
            {percentage}
            %
          </span>
        </TooltipRow>
        <Divider style={{ width: '100%' }} />
        <TooltipRow>
          <Building07Icon color={colors.icon['strong-900']} size="16" />
          <span>{t('unidades')}</span>
          <span>{units}</span>
        </TooltipRow>
      </TooltipContainer>
    </GraphTooltip>
  );
}
